<template>
  <div>
    <div class="billing-detail-header">
      <span class="billing-detail-item">御利用月：{{ filteredMonthName }}</span>
      <span class="billing-detail-item">御法人名：{{ selectedCorporationName }}</span>
      <span class="billing-detail-item">項目：{{ billingItemName }}</span>
    </div>
    <button type="button" class="btn btn-gray" @click="exportToExcel">
      エクスポート
    </button>
    <button type="button" class="btn btn-gray" @click="exportToPdf">プリント</button>
    <div class="form-group float-right">
      <label for="text1">検索:</label>
      <input type="text" id="searchform_small" class="form-control" v-model="filter" />
    </div>

    <form class="form-inline showall">
      <div class="form-sort align-items-center">
        <div class="item-count col-2 my-1">
          <label class="mr-sm-2 sr-only" for="inlineFormCustomSelectSmall">
            Preference
          </label>
          <select class="custom-select mr-sm-2" id="inlineFormCustomSelectSmall" v-model="perPage">
            <option :value="totalBillingDetails" selected>全</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
            <option :value="150">150</option>
          </select>
          件表示
        </div>
      </div>
    </form>

    <div class="tab-content">
      <div id="table-1" class="tab-pane active">
        <div class="table-wrapper-scroll-y">
          <b-table
            ref="billing-detail-table"
            :min-width="tableWidth"
            class="sticky-table"
            selectable
            responsive
            sticky-header
            foot-clone
            no-footer-sorting
            :fields="fields"
            :filter="filter"
            :filterIncludedFields="searchableFields"
            :per-page="perPage"
            :current-page="currentPage"
            :items="resourcesFiltered"
            :refreshed="tableRefreshed()"
          >
            <template v-slot:head()="scope">
              <div class="text-nowrap">
                <b>{{ scope.label }}</b>
              </div>
            </template>

            <template v-slot:cell(status)="row">
              <div class="b-table-column-background-white">
                {{ row.value }}
              </div>
            </template>

            <template v-slot:cell(action)="row">
              <a class="hyper-text" @click="changeStatus(row)">
                判定修正
              </a>
            </template>

            <template v-slot:foot()="data">
              <div class="footFilters" v-show="data.field.footFilterable">
                <v-select
                  tag="div"
                  v-model="footFilters[data.column]"
                  placeholder="フィルタ"
                  class="select-control"
                  :options="tableFootOptions[data.column]"
                  :appendToBody="true"
                />
              </div>
            </template>
          </b-table>
        </div>
        <div class="pagination-footer">
          <label> {{ totalBillingDetails }} 件中 {{ baseIndex }} から {{ capIndex }} まで表示 </label>
          <div class="float-right">
            <button :disabled="!hasPreviousPage" type="button" class="btn btn-invisible" @click="goToPreviousPage">
              前
            </button>
            <label class="pagination-border text-center">{{ currentPage }}</label>
            <button :disabled="!hasNextPage" type="button" class="btn btn-invisible" @click="goToNextPage">
              次
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { sumObjectArrayByKey } from '@/utils/math_helpers.js';
import { updateStickyColumnsAndMinWidth } from '@/helpers/sticky_table';
import { resourcesFiltered, tableFootOptions } from '@/helpers/table';
import { basicFieldPresent, basicPresent, basicBillingTypeIdDisplay } from '@/presenters/fields';
import XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import { buildJapaneseFont } from '@/helpers/PdfCustomFont.js';

export default {
  props: {
    filteredMonthName: {
      type: String,
      default: '',
    },
    selectedCorporationName: {
      type: String,
      default: '',
    },
    billingItem: {
      type: Object,
      default: null,
    },
  },
  data() {
    var fields = [
      {
        key: 'brand',
        enable: true,
        label: 'ブランド名',
        sortable: true,
        searchable: true,
        thAttr: { width: 150 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return this.brandNameDisplay(value);
        },
        footFilterable: true,
        footOptions: (value) => {
          return this.brandNameDisplay(value);
        },
      },
      {
        key: 'teacherId',
        enable: true,
        label: '先生ID',
        sortable: true,
        searchable: true,
        thAttr: { width: 150 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return this.teacherIdDisplay(value);
        },
      },
      {
        key: 'name',
        enable: true,
        label: '先生名',
        sortable: true,
        searchable: true,
        thAttr: { width: 150 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return this.teacherNameDisplay(value);
        },
      },
    ];
    if (this.$store.getters['role/hasAdminPrivilege']) {
      fields.push({
        key: 'status',
        enable: true,
        label: '判定',
        sortable: false,
        searchable: false,
        class: 'sticky-column right-sticky-column-2',
        thAttr: { width: 150 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return this.statusDisplay(value);
        },
        footFilterable: true,
        footOptions: (value) => {
          return this.statusDisplay(value);
        },
      });
      fields.push({
        key: 'action',
        enable: true,
        label: '',
        sortable: false,
        searchable: false,
        class: 'sticky-column right-sticky-column-1',
        thAttr: { width: 100 },
      });
    } else {
      fields.push({
        key: 'status',
        enable: true,
        label: '判定',
        sortable: false,
        searchable: false,
        class: 'sticky-column right-sticky-column-1',
        thAttr: { width: 150 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return this.statusDisplay(value);
        },
        footFilterable: true,
        footOptions: (value) => {
          return this.statusDisplay(value);
        },
      });
    }
    return {
      fields: fields,
      currentPage: 1,
      perPage: 50,
      selectAll: false,
      filter: null,
      footFilters: {},
    };
  },
  mounted() {},
  computed: {
    resources() {
      return this.billing.billingDetails;
    },
    resourcesFiltered() {
      return resourcesFiltered(this.resources, this.fields, this.footFilters);
    },
    tableFootOptions() {
      return tableFootOptions(this.resources, this.fields);
    },

    baseIndex() {
      return (this.currentPage - 1) * this.perPage + 1;
    },
    capIndex() {
      return Math.min(this.baseIndex + this.perPage - 1, this.totalBillingDetails);
    },
    hasPreviousPage() {
      return this.currentPage > 1;
    },
    hasNextPage() {
      return this.totalBillingDetails > this.currentPage * this.perPage;
    },
    searchableFields() {
      var fields = this.fields.filter((field) => field.enable == true && field.searchable == true);
      return fields.map((field) => field.key);
    },
    tableWidth() {
      return sumObjectArrayByKey(this.fields, 'thAttr', 'width') + 'px';
    },
    billingItemName() {
      if (this.billingItem) {
        return basicBillingTypeIdDisplay(this.billingItem.billingTypeId);
      }
      return '';
    },
    ...mapState(['billing']),
    ...mapGetters('billing', [
      'totalBillingDetails',
      'getBillingDetailById',
      'getExcelFormattedTeacherBillingDetails',
      'getExcelHeaderTeacherBillingDetails',
    ]),
    ...mapGetters('role', ['hasAdminPrivilege']),
  },
  methods: {
    tableRefreshed() {
      this.$logger.debug('Table refreshed');
      if (this.hasAdminPrivilege) {
        updateStickyColumnsAndMinWidth({ leftColumns: 0, rightColumns: 2 });
      } else {
        updateStickyColumnsAndMinWidth({ leftColumns: 0, rightColumns: 1 });
      }
    },
    goToPreviousPage() {
      this.selectAll = false;
      this.currentPage--;
    },
    goToNextPage() {
      this.selectAll = false;
      this.currentPage++;
    },
    brandNameDisplay(brand) {
      return basicFieldPresent(brand, 'name');
    },
    teacherIdDisplay(teacherId) {
      return basicPresent(teacherId);
    },
    teacherNameDisplay(teacherName) {
      return basicPresent(teacherName);
    },
    statusDisplay(field) {
      switch (field) {
        case 'billable':
          return '請求対象';
        case 'unbillable':
          return '請求対象外';
        default:
          return '初月無料';
      }
    },
    exportToExcel() {
      this.$logger.debug('Export Billing Details to Excel');
      var billingWS = XLSX.utils.json_to_sheet(this.getExcelFormattedTeacherBillingDetails);
      var wb = XLSX.utils.book_new(); // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, billingWS, 'Billing Details'); // add Worksheet to Workbook
      XLSX.writeFile(wb, 'billing_details.xlsx');
    },
    createHeaders(keys) {
      return keys.map((key) => ({
        name: key,
        prompt: key,
        width: 128,
        align: 'center',
        padding: 0,
      }));
    },
    exportToPdf() {
      this.$logger.debug('Print Billing Details to PDF');
      let doc = new jsPDF({ orientation: 'l', format: 'a4' });
      buildJapaneseFont(doc);
      doc.table(
        4,
        4,
        this.getExcelFormattedTeacherBillingDetails,
        this.createHeaders(this.getExcelHeaderTeacherBillingDetails)
      );
      doc.autoPrint();
      if (this.getExcelHeaderTeacherBillingDetails.length > 150) {
        this.$logger.debug('Data too big, can only save');
        doc.save('billing_details.pdf', { returnPromise: true }).then(() => {
          this.$logger.debug('PDF saved successfully');
        });
      } else {
        this.$logger.debug('Data OK, Print from new window');
        doc.output('dataurlnewwindow', { filename: 'billing_details.pdf' });
      }
    },
    changeStatus(row) {
      this.$logger.debug('Change Billing Status with Id: ' + row.item.id);
      let billingDetail = this.getBillingDetailById(row.item.id);
      this.$emit('changeTeacherBillingDetail', billingDetail);
    },
  },
};
</script>

<style scoped>
.billing-detail-header {
  margin-left: 20px;
  margin-bottom: 30px;
}
.billing-detail-item {
  margin-right: 20px;
}
.btn-sm {
  margin-left: 0px;
}
.btn-gray {
  margin-bottom: 5px;
}
.item-count {
  padding: 0;
  font-size: 10px;
}
.custom-control-label {
  font-weight: normal;
}
.pagination-footer {
  margin-top: 20px;
}
.hyper-text {
  color: #227afa;
  cursor: pointer;
}
</style>
